import _typeof from "@babel/runtime/helpers/typeof";
import { SLIDES_PER_VIEW_DEFAULT_VALUE } from "../constants";
export var shouldShowNextArrow = function shouldShowNextArrow(_ref) {
  var lastSlideVisible = _ref.lastSlideVisible,
    slidesCount = _ref.slidesCount,
    _ref$currentSlide = _ref.currentSlide,
    currentSlide = _ref$currentSlide === void 0 ? 0 : _ref$currentSlide,
    slider = _ref.slider;
  var _ref2 = slider !== null && slider !== void 0 ? slider : {},
    loop = _ref2.loop,
    slides = _ref2.slides;
  var isAutoPerView = _typeof(slides) === 'object' && (slides === null || slides === void 0 ? void 0 : slides.perView) === 'auto';
  var perView = _typeof(slides) === 'object' && typeof (slides === null || slides === void 0 ? void 0 : slides.perView) === 'number' ? slides.perView : SLIDES_PER_VIEW_DEFAULT_VALUE;
  if (loop === undefined || loop === false) {
    if (isAutoPerView) {
      return !lastSlideVisible;
    }
    return currentSlide !== slidesCount - perView;
  }
  if (loop === true) {
    return true;
  }
  return loop.max === undefined || currentSlide < loop.max - perView + 1;
};
//# sourceMappingURL=shouldShowNextArrow.js.map